export default __webpack_public_path__ + "static/media/truck.12839b49.svg";